import React from 'react';
import styled from 'styled-components';

import { Logo } from './';
import { Menu } from '../../navigation/components';

const StyledHeader = styled.header`
  box-sizing: border-box;
  //padding: 2.8125rem 1.875rem;
  padding: 2.4375rem 1.875rem;
  position: absolute;
  z-index: 1000;
`;

const AppHeader = props => {
  return (
    <StyledHeader>
      <Logo />
      <Menu />
    </StyledHeader>
  );
};

export default AppHeader;



// WEBPACK FOOTER //
// ./src/modules/core/components/AppHeader.js